/* eslint-disable */
import axios, { AxiosInstance } from 'axios'
import { Alert, Message, MessageBox } from 'element-ui'
import qs from 'qs'
import Cookies from 'js-cookie';
import store from '@/store';
interface ResponseData<T = any> {
  /**
   * 状态码
   * @type { number }
   */
  code: number

  /**
   * 数据
   * @type { T }
   */
  rows: T

  /**
   * 消息
   * @type { string }
   */
  msg: string
}
class request {
  // http请求对象
  public service
  constructor() {

    this.service = axios.create({
      baseURL: process.env.VUE_APP_BASE_API || "",
      timeout: 500000,
      headers:{
        "Content-Type":"application/x-www-form-urlencoded"
      }
    })

    // Request interceptors
    this.service.interceptors.request.use(
      async (config: any) => {
        if(config.headers['Content-Type']=="application/x-www-form-urlencoded"){
          console.log("========")
          config.data = qs.stringify(config.data)
        }
        config.headers['authorization'] = store.state.token
        // console.log(process.env.VUE_APP_BASE_API)
        // console.log(config)
        return config
      },
      (error: any) => {
        Promise.reject(error)
      }
    )

    // Response interceptors
    this.service.interceptors.response.use(
      (response) => {
        // Some example codes here:
        // code == 20000: success
        // code == 50001: invalid access token
        // code == 50002: already login in other place
        // code == 50003: access token expired
        // code == 50004: invalid user (user not exist)
        // code == 50005: username or password is incorrect
        // You can change this part for your own usage.
        if (response.status != 200) {
          return Promise.reject(new Error('接口错误'))
        }
        const res: ResponseData = response.data
        // console.log(res)
        if (res.code != 1) {
          Message({
            message: res.msg || 'Error',
            type: 'error',
            duration: 5 * 1000,
            customClass: "message"
          })
          if (res.code == 401) {
            MessageBox.alert(
              '登陆过期，重新登录',
              '提示',
              {
                confirmButtonText: '重新登录',
                type: 'error',
                showClose: false,
                customClass: "message",
                callback: () => {
                  store.commit("LoginOut")
                  location.reload() // To prevent bugs from vue-router
                }
              }
            )
          }
          return Promise.reject(new Error(res.msg || 'Error'))
        } else {
          return response.data.data
        }
      },
      (error: any) => {
        Message({
          message:  "请求数据出错",
          type: 'error',
          duration: 5 * 1000,
          customClass: "message"
        })
        return Promise.reject(error)
      }
    )
  }



}

export default new request().service

